import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { defaultNavigation } from 'app/mock-api/common/navigation/data';
import { cloneDeep } from 'lodash-es';
import { ChainService } from '../services/chain.service';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
    private  _defaultNavigation: FuseNavigationItem[] =
        defaultNavigation;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService,private chainService: ChainService) {
       
        this.registerHandlers();
    }

   
    registerHandlers(): void {
        
        this._fuseMockApiService.onGet('api/common/navigation').reply(() => {
            const navigation = cloneDeep(this._defaultNavigation);
            return [
                200,
                {
                    default: navigation,
                },
            ];
        });
    }
}
